function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M122 231C189.379 231 244 223.613 244 214.5V196.5C244 205.613 189.379 213 122 213C54.6213 213 0 205.613 0 196.5V214.5C0 223.613 54.6213 231 122 231Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M122 231C189.379 231 244 223.613 244 214.5V196.5H122H0V214.5C0 223.613 54.6213 231 122 231Z",
  fill: "url(#paint0_linear)",
  fillOpacity: 0.25
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 122,
  cy: 196.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 122,
  cy: 196.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint1_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M122 213C189.379 213 244 205.613 244 196.5C244 196.5 244 195.5 243.5 195.5C238.5 200 224.144 203.187 192 206C155 209.237 113.5 209.864 72.5 208C59.3234 207.401 6.5 203.5 0.500003 195C0 196 0 196.5 0 196.5C0 205.613 54.6213 213 122 213Z",
  fill: "url(#paint2_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M128 209C195.379 209 250 201.613 250 192.5V174.5C250 183.613 195.379 191 128 191C60.6213 191 6 183.613 6 174.5V192.5C6 201.613 60.6213 209 128 209Z",
  fill: "currentColor"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M128 209C195.379 209 250 201.613 250 192.5V174.5H128H6V192.5C6 201.613 60.6213 209 128 209Z",
  fill: "url(#paint3_linear)",
  fillOpacity: 0.25
});

var _ref9 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 128,
  cy: 174.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref10 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 128,
  cy: 174.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint4_linear)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M128 191C195.379 191 250 183.613 250 174.5C250 174.5 250 173.5 249.5 173.5C244.5 178 230.144 181.187 198 184C161 187.237 119.5 187.864 78.5 186C65.3234 185.401 12.5 181.5 6.5 173C6 174 6 174.5 6 174.5C6 183.613 60.6213 191 128 191Z",
  fill: "url(#paint5_linear)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M124 186C191.379 186 246 178.613 246 169.5V151.5C246 160.613 191.379 168 124 168C56.6213 168 2 160.613 2 151.5V169.5C2 178.613 56.6213 186 124 186Z",
  fill: "currentColor"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M124 186C191.379 186 246 178.613 246 169.5V151.5H124H2V169.5C2 178.613 56.6213 186 124 186Z",
  fill: "url(#paint6_linear)",
  fillOpacity: 0.25
});

var _ref14 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 124,
  cy: 151.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref15 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 124,
  cy: 151.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint7_linear)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M124 168C191.379 168 246 160.613 246 151.5C246 151.5 246 150.5 245.5 150.5C240.5 155 226.144 158.187 194 161C157 164.237 115.5 164.864 74.5 163C61.3234 162.401 8.5 158.5 2.5 150C2 151 2 151.5 2 151.5C2 160.613 56.6213 168 124 168Z",
  fill: "url(#paint8_linear)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M127 164C194.379 164 249 156.613 249 147.5V129.5C249 138.613 194.379 146 127 146C59.6213 146 5 138.613 5 129.5V147.5C5 156.613 59.6213 164 127 164Z",
  fill: "currentColor"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M127 164C194.379 164 249 156.613 249 147.5V129.5H127H5V147.5C5 156.613 59.6213 164 127 164Z",
  fill: "url(#paint9_linear)",
  fillOpacity: 0.25
});

var _ref19 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 127,
  cy: 129.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref20 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 127,
  cy: 129.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint10_linear)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M127 146C194.379 146 249 138.613 249 129.5C249 129.5 249 128.5 248.5 128.5C243.5 133 229.144 136.187 197 139C160 142.237 118.5 142.864 77.5 141C64.3234 140.401 11.5 136.5 5.5 128C5 129 5 129.5 5 129.5C5 138.613 59.6213 146 127 146Z",
  fill: "url(#paint11_linear)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M131 139C198.379 139 253 131.613 253 122.5V104.5C253 113.613 198.379 121 131 121C63.6213 121 9 113.613 9 104.5V122.5C9 131.613 63.6213 139 131 139Z",
  fill: "currentColor"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M131 139C198.379 139 253 131.613 253 122.5V104.5H131H9V122.5C9 131.613 63.6213 139 131 139Z",
  fill: "url(#paint12_linear)",
  fillOpacity: 0.25
});

var _ref24 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 131,
  cy: 104.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref25 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 131,
  cy: 104.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint13_linear)"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M131 121C198.379 121 253 113.613 253 104.5C253 104.5 253 103.5 252.5 103.5C247.5 108 233.144 111.187 201 114C164 117.237 122.5 117.864 81.5 116C68.3234 115.401 15.5 111.5 9.5 103C9 104 9 104.5 9 104.5C9 113.613 63.6213 121 131 121Z",
  fill: "url(#paint14_linear)"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M122 117C189.379 117 244 109.613 244 100.5V82.5C244 91.6127 189.379 99 122 99C54.6213 99 0 91.6127 0 82.5V100.5C0 109.613 54.6213 117 122 117Z",
  fill: "currentColor"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M122 117C189.379 117 244 109.613 244 100.5V82.5H122H0V100.5C0 109.613 54.6213 117 122 117Z",
  fill: "url(#paint15_linear)",
  fillOpacity: 0.25
});

var _ref29 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 122,
  cy: 82.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref30 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 122,
  cy: 82.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint16_linear)"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M122 99C189.379 99 244 91.6127 244 82.5C244 82.5 244 81.5 243.5 81.5C238.5 86 224.144 89.1874 192 92C155 95.2375 113.5 95.8636 72.5 94C59.3234 93.401 6.5 89.5 0.500003 81C0 82 0 82.5 0 82.5C0 91.6127 54.6213 99 122 99Z",
  fill: "url(#paint17_linear)"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M132 97.9999C199.379 97.9999 254 90.6126 254 81.4999V63.5C254 72.6127 199.379 80 132 80C64.6213 80 10 72.6127 10 63.5V81.4999C10 90.6126 64.6213 97.9999 132 97.9999Z",
  fill: "currentColor"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M132 97.9999C199.379 97.9999 254 90.6126 254 81.4999V63.5H132H10V81.4999C10 90.6126 64.6213 97.9999 132 97.9999Z",
  fill: "url(#paint18_linear)",
  fillOpacity: 0.25
});

var _ref34 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 132,
  cy: 63.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref35 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 132,
  cy: 63.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint19_linear)"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M132 80C199.379 80 254 72.6127 254 63.5C254 63.5 254 62.5 253.5 62.5C248.5 67 234.144 70.1874 202 73C165 76.2375 123.5 76.8636 82.5 75C69.3234 74.401 16.5 70.5 10.5 62C10 63 10 63.5 10 63.5C10 72.6127 64.6213 80 132 80Z",
  fill: "url(#paint20_linear)"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M124 72.9999C191.379 72.9999 246 65.6126 246 56.4999V38.5C246 47.6127 191.379 55 124 55C56.6213 55 2 47.6127 2 38.5V56.4999C2 65.6126 56.6213 72.9999 124 72.9999Z",
  fill: "currentColor"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M124 72.9999C191.379 72.9999 246 65.6126 246 56.4999V38.5H124H2V56.4999C2 65.6126 56.6213 72.9999 124 72.9999Z",
  fill: "url(#paint21_linear)",
  fillOpacity: 0.25
});

var _ref39 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 124,
  cy: 38.5,
  rx: 122,
  ry: 16.5,
  fill: "currentColor"
});

var _ref40 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 124,
  cy: 38.5,
  rx: 122,
  ry: 16.5,
  fill: "url(#paint22_linear)"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M124 55C191.379 55 246 47.6127 246 38.5C246 38.5 246 37.5 245.5 37.5C240.5 42 226.144 45.1874 194 48C157 51.2375 115.5 51.8636 74.5 50C61.3234 49.401 8.5 45.5 2.5 37C2 38 2 38.5 2 38.5C2 47.6127 56.6213 55 124 55Z",
  fill: "url(#paint23_linear)"
});

var _ref42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 244,
  y1: 231,
  x2: 118,
  y2: 231,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 137,
  y1: 185,
  x2: 122,
  y2: 207,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: -3.63368e-8,
  y1: 213,
  x2: 244,
  y2: 213,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 250,
  y1: 209,
  x2: 124,
  y2: 209,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 143,
  y1: 163,
  x2: 128,
  y2: 185,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.17
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 6,
  y1: 191,
  x2: 250,
  y2: 191,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 246,
  y1: 186,
  x2: 120,
  y2: 186,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 139,
  y1: 140,
  x2: 124,
  y2: 162,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 2,
  y1: 168,
  x2: 246,
  y2: 168,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear",
  x1: 249,
  y1: 164,
  x2: 123,
  y2: 164,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear",
  x1: 142,
  y1: 118,
  x2: 127,
  y2: 140,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear",
  x1: 5,
  y1: 146,
  x2: 249,
  y2: 146,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear",
  x1: 253,
  y1: 139,
  x2: 127,
  y2: 139,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear",
  x1: 146,
  y1: 93,
  x2: 131,
  y2: 115,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.17
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear",
  x1: 9,
  y1: 121,
  x2: 253,
  y2: 121,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear",
  x1: 244,
  y1: 117,
  x2: 118,
  y2: 117,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear",
  x1: 137,
  y1: 71,
  x2: 122,
  y2: 93,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear",
  x1: -3.63368e-8,
  y1: 98.9999,
  x2: 244,
  y2: 98.9999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint18_linear",
  x1: 254,
  y1: 98,
  x2: 128,
  y2: 98,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint19_linear",
  x1: 147,
  y1: 52,
  x2: 132,
  y2: 74,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.14
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint20_linear",
  x1: 10,
  y1: 79.9999,
  x2: 254,
  y2: 79.9999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint21_linear",
  x1: 246,
  y1: 73,
  x2: 120,
  y2: 73,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C4C4C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0001,
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0.67
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint22_linear",
  x1: 139,
  y1: 27,
  x2: 124,
  y2: 49,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopOpacity: 0.03
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint23_linear",
  x1: 2,
  y1: 54.9999,
  x2: 246,
  y2: 54.9999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.45
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.303264,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.36
})));

function Svg8Chip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 239,
    viewBox: "0 0 259 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg8Chip);
export default __webpack_public_path__ + "static/media/8chip.4a112825.svg";
export { ForwardRef as ReactComponent };